<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Transactions"
              bc1="App"
              bc2="Transactions"
              bc3="Details"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$emit('backFromDetailPage')"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section v-if="!isEmpty(transactionDetails)" class="invoice-preview-wrapper">
          <div class="row invoice-preview">
            <!-- Invoice -->
            <div class="col-12">
              <div class="card invoice-preview-card">
                <div class="card-body invoice-padding pb-0">
                  <!-- Header starts -->
                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                    <div>
                      <div class="logo-wrapper">
                        <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                      </div>
                      <p class="card-text mb-25">Payment Method: {{ transactionDetails.payment_method.name }}</p>
                      <p class="card-text mb-25">Gateway Ref Id:
                        {{ transactionDetails.gateway_reference_id ? transactionDetails.gateway_reference_id : 'N/A' }}</p>
                      <p class="card-text mb-0">Transaction Type: {{ transactionDetails.transaction_type.name }}</p>
                      <p class="card-text mb-0">Card Holder Name: <span class="badge badge-sm badge-glow badge-light-info">{{ transactionDetails.card_holder_name }}</span></p>
                      <p class="card-text mb-0">Card Number: {{ transactionDetails.card_number }}</p>
                      <p class="card-text mb-0">Amount: <span class="text-warning">{{ parseFloat(transactionDetails.amount/100).toFixed(amountDecimalPlaces) }}</span></p>
                      <p class="card-text mb-0" >Currency:  <span class="badge mt-1  badge-glow badge-light-success">{{ transactionDetails.currency.code }}</span></p>


                    </div>
                    <div class="mt-md-0 mt-2">
                      <h4 class="invoice-title">
                        Transaction
                        <span class="invoice-number">#{{ transactionDetails.uuid }}</span>
                      </h4>
                      <div class="invoice-date-wrapper justify-content-end">
                        <p class="invoice-date-title">Date Created:</p>
                        <p class="invoice-date">{{
                            customFormatDateTime(transactionDetails.created_at)
                          }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- Header ends -->
                </div>

                <hr class="invoice-spacing"/>


                <div class="card-body invoice-padding pt-0">
                  <div class="row invoice-spacing">
                    <div class="col-xl-8 p-0" v-if="transactionDetails.customer">
                      <h6 class="mb-2">Customer Details:</h6>
                      <h6 class="mb-25">Name: {{transactionDetails.customer.name }}</h6>
                      <p class="card-text mb-25">Email: {{transactionDetails.customer.email}} </p>
                      <p class="card-text mb-25">Phone: {{transactionDetails.customer.phone}}</p>
                    </div>
                    <div class="col-xl-4 p-0 mt-xl-0 mt-2" v-if="transactionDetails.user">
                      <h6 class="mb-2">User Details:</h6>
                      <h6 class="mb-25">Name: {{transactionDetails.user.first_name + ' '+ transactionDetails.user.last_name }}</h6>
                      <p class="card-text mb-25">Email: {{transactionDetails.user.email}} </p>
                    </div>
                  </div>
                </div>

                <!-- Invoice Description ends -->

                <hr class="invoice-spacing"/>

                <!-- Invoice Note starts -->
                <div class="card-body invoice-padding pt-0">
                  <div class="row">
                    <div class="col-12">
                      <span class="font-weight-bold">Note:</span>
                      <span>It was a pleasure working with you and your team. We hope you will keep us in mind. Thank You!</span>
                    </div>
                  </div>
                </div>
                <!-- Invoice Note ends -->
              </div>
            </div>
            <!-- /Invoice -->

          </div>
        </section>


      </div>
    </div>
  </div>
</template>

<script>

export default {
  props:['rowData'],
  mounted() {
    this.transactionDetails = this.rowData
  },
  data() {
    return {
      transactionDetails: []

    }
  },
  methods: {},
  watch:{
    rowData(val){
      this.transactionDetails = val
    }
  }

}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>

